import React from 'react';

const Exposure = ({ className }) => {
    return (
        <svg className="icon-exposure" width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="23" cy="23" r="23" fill="#232328" />
            <circle className='c2' cx="23.5" cy="23.5" r="7" fill="url(#paint0_linear_1744_10167)" stroke="white" />
            <defs>
                <linearGradient id="paint0_linear_1744_10167" x1="23.5" y1="16" x2="23.5" y2="31" gradientUnits="userSpaceOnUse">
                    <stop className='stop1' stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default Exposure;